import { AbsoluteResolvedModelPath } from "../ModelPath";
import { EachCurrentCollision } from "../EachCurrentCollision";

import { Set2 } from "./Set2";

export class AbsoluteResolvedModelPathSet extends Set2<AbsoluteResolvedModelPath> {
    private readonly eachCurrentCollision: EachCurrentCollision;

    public constructor(eachCurrentCollision: EachCurrentCollision = EachCurrentCollision.AreSame) {
        super();
        this.eachCurrentCollision = eachCurrentCollision;
    }

    public static *unique(paths: Iterable<AbsoluteResolvedModelPath>): Iterable<AbsoluteResolvedModelPath> {
        const set = new AbsoluteResolvedModelPathSet();
        for (const path of paths) {
            if (set.add(path)) {
                yield path;
            }
        }
    }

    protected areItemsEqual(left: AbsoluteResolvedModelPath, right: AbsoluteResolvedModelPath): boolean {
        return left.isEquals(right, this.eachCurrentCollision);
    }

    protected getItemHash(key: AbsoluteResolvedModelPath): number {
        return key.getHash(this.eachCurrentCollision);
    }
}
